import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledCheckAllWrapper,
  StyledCheckboxGroup,
  StyledCheckboxGroupOuter,
  StyledRotatingIconButton,
} from '../styles';
import { FIELD_TYPES } from 'utility/constants';
import Icon, { IconSizing } from '__components/Kizen/Icon';
import { colorsButton } from 'app/colors';
import { ApplyAllCheckbox } from './ApplyAllCheckbox';

type Option = {
  label: string;
  value: string;
  data: {
    id: string;
    name: string;
  };
};

export const ExportGroup: FC<{
  label: string;
  options: Option[];
  selected: Option[];
  setSelected: (selected: Option[]) => void;
  keyListenersProps?: Record<string, any>;
}> = ({ label, options, selected, setSelected, keyListenersProps }) => {
  const { t } = useTranslation();
  const selectAll = () => setSelected(options);
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <>
      <StyledCheckAllWrapper data-qa-label={label}>
        <ApplyAllCheckbox
          label={`${label} (${selected.length} / ${options.length})`}
          onCheck={selectAll}
        />
        <StyledRotatingIconButton
          sizing="dense"
          color={colorsButton.iconGray}
          onClick={toggleExpanded}
          expanded={expanded}
          title={expanded ? t('Collapse') : t('Expand')}
        >
          <IconSizing size="14px">
            <Icon icon="chevron-down" />
          </IconSizing>
        </StyledRotatingIconButton>
      </StyledCheckAllWrapper>
      <StyledCheckboxGroupOuter expanded={expanded}>
        <StyledCheckboxGroup
          data-qa-label={`${label} options`}
          value={selected}
          onChange={setSelected}
          options={options}
          {...keyListenersProps}
          fieldType={FIELD_TYPES.Checkboxes.type}
          expanded={expanded}
          maxHeight={options.length * 27}
        />
      </StyledCheckboxGroupOuter>
    </>
  );
};
